export default [
  {
    path: "/audit/mutation",
    name: "audit-mutation",
    component: () => import("@/views/audit/mutation/AuditMutation.vue"),
    meta: {
      pageTitle: "Mutation Audit",
      action: "view",
      resource: "audit-mutation",
      breadcrumb: [
        {
          text: "Mutation Audit",
          active: true
        }
      ]
    }
  }
];
